import { render } from "./commande.vue?vue&type=template&id=74b2f3e0&scoped=true"
import script from "./commande.vue?vue&type=script&lang=js"
export * from "./commande.vue?vue&type=script&lang=js"

import "./commande.vue?vue&type=style&index=0&id=74b2f3e0&lang=scss&scoped=true"

import exportComponent from "/usr/src/oho-accounting-test/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74b2f3e0"]])

export default __exports__